export enum GrayColorToken {
  gray25 = '#FCFCFD',
  gray50 = '#F9FAFB',
  gray100 = '#F2F4F7',
  gray200 = '#EAECF0',
  gray300 = '#D0D5DD',
  gray400 = '#98A2B3',
  gray500 = '#667085',
  gray600 = '#475467',
  gray700 = '#344054',
  gray800 = '#1D2939',
  gray900 = '#101828',
}

export default GrayColorToken

export type TGray =
  | 'gray25'
  | 'gray50'
  | 'gray100'
  | 'gray200'
  | 'gray300'
  | 'gray400'
  | 'gray500'
  | 'gray600'
  | 'gray700'
  | 'gray800'
  | 'gray900'
